import { IBarcodeScannerPluginSetting } from './model';

export type ScanResult = {
  code: string;
}

export type ScanResultCallback = (result: ScanResult) => void;

export type ScanErrorCallback = (error: unknown) => void;

export abstract class ScannerPluginWrapperBase {
  private callback: ScanResultCallback | undefined;
  private errorCallback: ScanErrorCallback | undefined;

  setScanCallback(callback: ScanResultCallback) {
    this.callback = callback;
  }

  setScanErrorCallback(callback: ScanErrorCallback) {
    this.errorCallback = callback;
  }

  abstract startScan(options: IBarcodeScannerPluginSetting): Promise<void>;

  abstract stopScan(): Promise<void>;

  abstract checkPermission(): Promise<boolean>;

  onResult(result: ScanResult) {
    if (this.callback) {
      this.callback(result);
    }
  }

  onError(error: unknown) {
    if (this.errorCallback) {
      this.errorCallback(error);
    }
  }
}
